<template>
  <div class="touch-demo-page">
    <div class="box _gradient-bar">
      <div class="box-1">
        <h1>
          Take a tour of the Vendor Software
        </h1>
        <p>
          Alongside a FREE Month Trial we are now offering FREE access to a full demo of Vendor.
          Giving you access to the sales and survey designer, website designer, paperwork and Vendor Dashboard
        </p>
        <div class="image">
          <img src="/images/touch-demo/vendordemo-intro.jpg">
        </div>
      </div>
      <div class="box-2">
        <div>
          <h1>
            All this included in Vendor as standard
          </h1>
        </div>
        <div class="cols">
          <div class="col">
            <div class="box">
              <div class="image">
                <img src="/images/touch-demo/main-demo.jpg">
              </div>
              <div class="content">
                <h2>
                  Main Demo
                </h2>
                <p>
                  Includes access to:<br>
                  Vendor setup process, pricing and products<br>
                  Vendor Dashboard<br>
                  Quote and survey designer
                </p>
                <div class="mt-a">
                  <a class="btn-primary" href="https://vendor.bm-touch.co.uk/logindemo" target="_blank">
                    Start Demo
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="box">
              <div class="image">
                <img src="/images/touch-demo/webdesigner-demo.jpg">
              </div>
              <div class="content">
                <h2>
                  Website Designer Demo
                </h2>
                <p>
                  The website designer demo will show you how your designer will look one you click a link from your current website. This would be branded with your logo.
                </p>
                <div class="mt-a">
                  <a class="btn-primary" href="https://vendor.bm-touch.co.uk/launch/demo-bm" target="_blank">
                    Start Demo
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="box-3">
        <h3>
          View the email and paperwork that's available as standard with Vendor
        </h3>
      </div>

      <div class="box-4">
        <div class="cols">
          <div class="col">
            <div class="box">
              <img src="/images/touch-demo/thumb-customerenquiryemail.jpg">
              <div class="content">
                <h2>Customer Enquiry Email</h2>
                <p>This is the email that a customer will automatically receive once they make an enquiry via the website designer. This will be branded with your logo.</p>
                <div class="mt-a">
                  <a href="/images/touch-demo/customerenquiryemail.jpg" target="_blank" class="btn-primary"><i class="fal fa-envelope-open-text"></i>View
                    Email</a>
                </div>
              </div>
            </div>
          </div>

          <div class="col">
            <div class="box">
              <img src="/images/touch-demo/thumb-customerenquirypdf.jpg">
              <div class="content">
                <h2>Customer Enquiry PDF</h2>
                <p>This is the PDF that a customer will automatically receive as an attachment with the customer enquiry email.</p>
                <div class="mt-a">
                  <a href="/images/touch-demo/customerenquirypdf.pdf" target="_blank" class="btn-primary"><i class="fal fa-file-pdf"></i>View PDF</a>
                </div>
              </div>
            </div>
          </div>

          <div class="col">
            <div class="box">
              <img src="/images/touch-demo/thumb-customerrequotepdf.jpg">
              <div class="content">
                <h2>Customer Re-Quote PDF</h2>
                <p>When you make an edit to a quote or update a price with the ‘quote my customer’ feature you can then download an updated PDF to email your customer.</p>
                <div class="mt-a">
                  <a href="/images/touch-demo/customerrequotepdf.pdf" target="_blank" class="btn-primary"><i class="fal fa-file-pdf"></i>View PDF</a>
                </div>
              </div>
            </div>
          </div>

          <div class="col">
            <div class="box">
              <img src="/images/touch-demo/thumb-surveysheetpdf.jpg">
              <div class="content">
                <h2>Survey Sheet PDF</h2>
                <p>Download a PDF summary of the customers enquiry allowing you to add technical information and measurements while in the customers home.</p>
                <div class="mt-a">
                  <a href="/images/touch-demo/surveysheetpdf.pdf" target="_blank" class="btn-primary"><i class="fal fa-file-pdf"></i>View PDF</a>
                </div>
              </div>
            </div>
          </div>

          <div class="col">
            <div class="box">
              <img src="/images/touch-demo/thumb-pricerequestpdf.jpg">
              <div class="content">
                <h2>Price Request PDF</h2>
                <p>Once you have finalised a customers options, you can download a PDF showing the complete product summary, this can then be sent to a supplier for a cost.</p>
                <div class="mt-a">
                  <a href="/images/touch-demo/pricerequestpdf.pdf" target="_blank" class="btn-primary"><i class="fal fa-file-pdf"></i>View PDF</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {},
};
</script>
